import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/views/Hello'
import Reset from '@/views/auth/Reset'
import Login from '@/views/auth/Login'
import Email from '@/views/auth/Email'
import Page404 from '@/views/errors/Page404'
import Full from '@/containers/Full'
import RoleList from '@/views/roles/RoleList'
import UserList from '@/views/users/UserList'
import PositionList from '@/views/positions/PositionList'
import CostCenterList from '@/views/cost_centers/CostCenterList'
import Company from '@/views/companies/Index'
import Employee from '@/views/employees/Index'
import Deductible from '@/views/deductibles/Deductibles'
import Provision from '@/views/provisions/Provision'
import Level from '@/views/levels/Level'
import Payrolls from '@/views/payrolls/Payrolls'
import Liquidation from '@/views/reports/Liquidation'
import TransportReport from '@/views/reports/Transport'
import LiquidationReport from '@/views/reports/LiquidationReport'
import TransportReportE from '@/views/reports/TransportReport'
import CivilStatus from '@/views/civilstatuses/CivilStatus'
import Templates from '@/views/templates/Template'
import DeductibleTypes from '@/views/deductible_types/DeductibleType'
import TransportExtras from '@/views/transportextras/TransportExtra'
import Account from '@/views/auth/Account'
import CheckIn from '@/views/checkins/Index'
import CheckInApproval from '@/views/checkins/approval/ApprovalPage'
import CheckInReport from '@/views/reports/CheckInReport'
import Bonuses from '@/views/bonuses/bonuses'
import BonusesReport from '@/views/reports/BonusesReport'
import Blacklist from '@/views/blacklist/blacklist'
import SalaryIncrease from '@/views/salary_increase/SalaryIncrease'
import SalaryIncreaseReport from '@/views/reports/SalaryIncreaseReport'
import VacationsReport from '@/views/reports/VacationsReport'
import EmployeeProfile from '@/views/employees/EmployeeProfile'
import RouterView from '@/containers/RouterView'
import Severance from '@/views/severance/Severance'

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/password/:token',
      component: Reset,
      meta: {
        guest: true
      }
    },
    {
      path: '/login',
      component: Login,
      meta: {
        guest: true
      }
    },
    {
      path: '/email',
      component: Email,
      meta: {
        guest: true
      }
    },
    {
      path: '/',
      meta: {
        auth: true
      },
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'account',
          name: 'Configuración de la Cuenta',
          component: Account
        },
        {
          path: 'dashboard',
          name: 'Escritorio',
          component: Hello
        },
        {
          meta: {
            permission: 'companies_s'
          },
          path: 'companies',
          name: 'Empresas',
          component: Company
        },
        {
          meta: {
            permission: 'employees_s'
          },
          path: 'employees',
          name: 'Empleados',
          children: [
            {
              path: '/',
              name: 'Todos los colaboradores',
              component: Employee
            },
            {
              path: ':employee/profile',
              name: 'Expediente Electronico',
              component: EmployeeProfile
            }
          ],
          component: RouterView
        },
        {
          meta: {
            permission: 'deductibles_s'
          },
          path: 'deductibles',
          name: 'Deducibles',
          component: Deductible
        },
        {
          meta: {
            permission: 'provisions_s'
          },
          path: 'provisions',
          name: 'Provisiones',
          component: Provision
        },
        {
          path: 'deductibletypes',
          name: 'Deducibles Variables',
          component: DeductibleTypes
        },
        {
          path: 'bonuses',
          name: 'Aguinaldos',
          component: Bonuses
        },
        {
          path: 'bonuses-report',
          name: 'Reporte de Aguinaldos',
          component: BonusesReport
        },
        {
          path: 'blacklist',
          name: 'Personas No Recontratables',
          component: Blacklist
        },
        {
          path: 'salary-increase',
          name: 'Aumento Salarial',
          component: SalaryIncrease
        },
        {
          path: 'salary-increase-report',
          name: 'Reporte Aumento Salarial',
          component: SalaryIncreaseReport
        },
        {
          path: 'vacations-report',
          name: 'Reporte Vacaciones',
          component: VacationsReport
        },
        {
          path: 'levels',
          name: 'Niveles de Incidencias',
          component: Level
        },
        {
          path: 'transportextras',
          name: 'Extras de transporte',
          component: TransportExtras
        },
        {
          path: 'civilstatus',
          name: 'Estados Civiles',
          component: CivilStatus
        },
        {
          meta: {
            permission: 'payrolls_s'
          },
          path: 'payrolls',
          name: 'Planillas',
          component: Payrolls
        },
        {
          meta: {
            permission: 'users_s'
          },
          path: 'users',
          name: 'Usuarios',
          component: UserList
        },
        {
          meta: {
            permission: 'checkin_s'
          },
          path: 'checkin',
          name: 'Asistencia',
          component: CheckIn
        },
        {
          meta: {
            permission: 'checkin_approval'
          },
          path: 'checkin/approval',
          name: 'Aprobación de Asistencia',
          component: CheckInApproval
        },
        {
          meta: {
            permission: 'roles_s'
          },
          path: 'roles',
          name: 'Roles',
          component: RoleList
        },
        {
          meta: {
            permission: 'cost_centers_s'
          },
          path: 'cost-centers',
          name: 'Centro de Costos',
          component: CostCenterList
        },
        {
          meta: {
            permission: 'positions_s'
          },
          path: 'positions',
          name: 'Puestos de Trabajo',
          component: PositionList
        },
        {
          path: 'report',
          name: 'Nomina',
          component: Liquidation
        },
        {
          path: 'transportreports',
          name: 'Herramienta de trabajo',
          component: TransportReport
        },
        {
          path: 'liquidation-report',
          name: 'Reporte de Nomina',
          component: LiquidationReport
        },
        {
          path: 'transport-report',
          name: 'Reporte de Herramienta de trabajo',
          component: TransportReportE
        },
        {
          path: 'templates',
          name: 'Planillas para contratos',
          component: Templates
        },
        {
          meta: {
            permission: 'checkin_s'
          },
          path: 'checkin-report',
          name: 'Reporte de Asistencia',
          component: CheckInReport
        },
        {
          path: 'severance',
          name: 'Cesantías',
          component: Severance
        }
      ]
    },
    {
      path: '*',
      component: Page404
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js